import "utils/domPatch";
import "./instrument";
import "./i18n";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./fonts.css";
import { Provider } from "react-redux";
import Router from "./router/Router";
import store from "./store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ThemeProvider } from "./context/ThemeContext";
import ThemeSync from "components/ThemeSync/ThemeSync";
import "react-before-after-slider-component/dist/build.css";
import "flag-icons/css/flag-icons.min.css";
import { initializeAnalytics } from "utils/analytics";
import { captureFirstTouchOnce } from "utils/firstTouchAttribution";

captureFirstTouchOnce();
initializeAnalytics();

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_API_KEY as string}>
      <React.StrictMode>
        <Provider store={store}>
          <ThemeProvider>
            <ThemeSync />
            <Router />
          </ThemeProvider>
        </Provider>
      </React.StrictMode>
    </GoogleOAuthProvider>
  );
}
